// Dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Logo = styled.img`
  width: 10em;
  height: 3em;
  padding: 0;
`

export const WrapperFooter = styled.footer`
  script {
    display: block;
  }

  &.hide {
    display: none;
  }

  .header {
    position: relative;
  }

  .scroll-event {
    background: #df1d3d;
    color: #ffffff;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    cursor: pointer;
    top: -25px;
    right: 18px;
    transform: rotate(90deg);
  }

  @media (min-width: 768px) {
    .scroll-event {
      right: 0;
    }
  }
`

export const ScrollToTopIconWrapper = styled.div`
  width: 48px !important;
  height: 48px !important;

  display: flex;
  align-items: center;
  justify-content: center !important;

  background-color: #df1d3d;
  border-radius: 8px;

  cursor: pointer;

  position: absolute;
  top: -24px;
  right: 8px;

  ${MediaQueries.medium} {
    top: -24px;
    right: 0px;
  }

  > .sisu-icon {
    cursor: pointer;
    transform: rotate(90deg);
  }
`
